import { HasChildren } from '@eppendorf/vnls-react-components';
import cn from 'classnames';
import { ReactElement } from 'react';

interface OverviewWrapperProps extends HasChildren {
  className?: string;
}

function OverviewWrapper({ children, className }: OverviewWrapperProps): ReactElement {
  return <div className={cn('box', className)}>{children}</div>;
}

function OverviewHeader({ children }: HasChildren): ReactElement {
  return (
    <div className="flex flex__jc--space-between flex__ai--center m-bottom-xxxl">
      {children}
    </div>
  );
}

function OverviewBody({ children }: HasChildren): ReactElement {
  return <div className="overflow-auto">{children}</div>;
}

export const Overview = Object.assign(OverviewWrapper, {
  Header: OverviewHeader,
  Body: OverviewBody,
});
